<template>
  <div>
    <RevDrawer
      name="MERCHANT.OPPORTUNITIES.INVENTORY.FILTERS"
      :title="i18n(translations.filter)"
    >
      <template #body>
        <div class="space-y-24">
          <RevInputText
            id="productTitle"
            v-model="values.productTitle"
            :label="i18n(translations.productSearch)"
            type="text"
          />

          <RevInputSelect
            id="categoryId"
            v-model="values.categoryId"
            :label="i18n(translations.categoryId)"
            :options="categoryOptions"
          />

          <RevInputSelect
            id="backboxGrade"
            v-model="values.backboxGrade"
            :label="i18n(translations.grade)"
            :options="gradeOptions"
          />

          <RevInputSelect
            id="currency"
            v-model="values.currency"
            :label="i18n(translations.currency)"
            :options="currencyFilterOptions"
          />

          <RevInputSelect
            id="competitionLevel"
            v-model="values.competitionLevel"
            :label="i18n(translations.competition)"
            :options="competitionOptions"
          />
        </div>
      </template>

      <template #footer="{ close }">
        <RevButton
          class="mb-8"
          full-width="always"
          variant="primary"
          @click="handleSubmit(close)"
        >
          {{ i18n(translations.viewResults) }}
        </RevButton>
        <RevButton
          class="mb-24"
          full-width="always"
          variant="secondary"
          @click="handleReset(close)"
        >
          {{ i18n(translations.resetFilters) }}
        </RevButton>
      </template>

      <template #trigger="{ open }">
        <RevStickyBar>
          <div class="flex items-center justify-center">
            <RevButton
              :icon="IconEqualizer"
              size="small"
              variant="secondary"
              @click="open"
            >
              {{ i18n(translations.filter) }}

              <RevTag
                v-if="currentFiltersCount > 0"
                :label="currentFiltersCount.toString()"
                variant="secondary"
              />
            </RevButton>
          </div>
        </RevStickyBar>
      </template>
    </RevDrawer>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevDrawer } from '@ds/components/Drawer'
import { type Option, RevInputSelect } from '@ds/components/InputSelect'
import { RevInputText } from '@ds/components/InputText'
import { RevStickyBar } from '@ds/components/StickyBar'
import { RevTag } from '@ds/components/Tag'
import { IconEqualizer } from '@ds/icons/IconEqualizer'

import { DEFAULT_INITIAL_VALUES } from '../Filters.constants'
import translations from '../Filters.translations'
import type { FilterValues } from '../Filters.types'

const emit = defineEmits(['submit'])
const props = defineProps<{
  initialValues: FilterValues
  gradeOptions: Option[]
  categoryOptions: Option[]
  currencyFilterOptions: Option[]
  competitionOptions: Option[]
}>()

const i18n = useI18n()
const values = ref({ ...props.initialValues })

const currentFiltersCount = computed(
  () =>
    Object.keys(DEFAULT_INITIAL_VALUES).filter(
      (key) =>
        values.value[key as keyof FilterValues] !==
        DEFAULT_INITIAL_VALUES[key as keyof FilterValues],
    ).length,
)

function handleSubmit(closeModalFunction: () => void) {
  emit('submit', values.value)
  closeModalFunction()
}

function handleReset(closeModalFunction: () => void) {
  values.value = { ...DEFAULT_INITIAL_VALUES }
  emit('submit', values.value)
  closeModalFunction()
}
</script>
